import { Box, VStack, makeUclComponent } from '@fhs-legacy/universal-components';
import LoadingAnimation from 'components/loading-animation';

export const Container = VStack.withConfig({
  width: 'full',
  height: 'full',
  maxWidth: { desktop: Styles.layout.smallerSectionMaxWidth },
  marginTop: { desktop: Styles.layout.navHeight.desktop },
  marginBottom: { base: '$8', desktop: Styles.layout.navHeight.desktop },
  marginX: 'auto',
  _text: {
    textAlign: 'center',
  },
  _android: {
    marginBottom: { base: '$0' },
  },
});

export const Loading = makeUclComponent(LoadingAnimation).withConfig<{ $windowHeight?: number }>(
  ({ $windowHeight }) => ({
    ...($windowHeight && { minHeight: $windowHeight - 107 }),
  })
);

export const SpinnerContainer = Box.withConfig({
  justifyContent: 'center',
  height: '100%',
});
